import React from 'react';
export default function footer() {
    return (React.createElement("footer", { id: 'footer', className: 'hide-for-print' },
        React.createElement("div", { className: 'row helper-margin-top-l' },
            React.createElement("div", { className: 'small-12 large-10 large-centered columns text-center' },
                React.createElement("small", null,
                    React.createElement("a", { href: 'http://www.en.uni-muenchen.de/imprint/index.html', target: '_blank' }, "Imprint"),
                    ' ',
                    "|",
                    ' ',
                    React.createElement("a", { href: 'http://www.en.uni-muenchen.de/privacy/index.html', target: '_blank' }, "Privacy disclaimer")))),
        React.createElement("div", { className: 'row helper-margin-top-m helper-padding-bottom-m' },
            React.createElement("div", { className: 'small-3 small-centered columns helper-textalign-center' },
                React.createElement("a", { href: '#top' },
                    React.createElement("img", { src: 'https://cms-static.uni-muenchen.de/default/foundation-zuv/img/footer-top.png', alt: "top" }))))));
}
